export default __webpack_public_path__ + "static/media/mechanism-capital.55369780.svg";